import React from "react";
import { Box, Button, CircularProgress, Divider, Typography } from "@mui/material";
import { formatLessonStart, formatPln } from "../../utils/paymentFormat";

// Shared presentational block: a list of lessons (name + start + price) closed
// by a total row. Used by both settlement pages (online bucket, on-site
// bucket). Presentational only — any pay action is injected from the parent.
//
// Props:
//   lessons        : [{ lesson_id, lesson_name, lesson_start, price }]
//   totalLabel     : node shown on the left of the total row
//   totalAmount    : number formatted as the total on the right
//   accentTotal    : when true the total amount uses the primary colour
//   onPayLesson    : optional (lessonId) => void; when provided each row shows
//                    a compact "Zapłać" button to pay that single lesson
//   payingLessonId : lesson_id whose payment is being submitted (row spinner)
//   payDisabled    : disable all per-row pay buttons while any action is busy
const LessonList = ({
  lessons,
  totalLabel,
  totalAmount,
  accentTotal = true,
  onPayLesson,
  payingLessonId = null,
  payDisabled = false,
}) => (
  <Box className="pay-for-lesson__list">
    {lessons.map((l) => (
      <Box key={l.lesson_id} className="pay-for-lesson__item">
        <Box className="pay-for-lesson__item-main">
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, lineHeight: 1.25 }}
          >
            {l.lesson_name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {formatLessonStart(l.lesson_start)}
          </Typography>
        </Box>
        <Box className="pay-for-lesson__item-side">
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, whiteSpace: "nowrap" }}
          >
            {formatPln(l.price)}
          </Typography>
          {onPayLesson && (
            <Button
              size="small"
              variant="outlined"
              className="pay-for-lesson__pay-one"
              onClick={() => onPayLesson(l.lesson_id)}
              disabled={payDisabled}
              startIcon={
                payingLessonId === l.lesson_id ? (
                  <CircularProgress size={14} color="inherit" />
                ) : null
              }
            >
              Zapłać
            </Button>
          )}
        </Box>
      </Box>
    ))}

    <Divider />

    <Box className="pay-for-lesson__item pay-for-lesson__total">
      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
        {totalLabel}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 800,
          whiteSpace: "nowrap",
          ...(accentTotal ? { color: "primary.main" } : {}),
        }}
      >
        {formatPln(totalAmount)}
      </Typography>
    </Box>
  </Box>
);

export default LessonList;
